<template>
	<div>
		<b-row class="mt-3">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
						<b-table
							class="w-100"
							:items="services"
							:fields="fields"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:filter="filter"
							:current-page="currentPage"
							:per-page="perPage"
							striped
							bordered
							hover
							small
							responsive="sm"
						>
							<template #cell(service_id)="data">
								<router-link :to="{ name: 'service', params: { id: data.value } }">
									{{ data.value }}
								</router-link>
							</template>
						</b-table>
				</b-row>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
export default {
	props: {
		services: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			sortBy: "created_at",
			sortDesc: true,
			filter: null,
			currentPage: 1,
			perPage: 10,
			perPageOptions: [10, 20, 30].map(n => ({text: `${n} ${this.$t("globals.per_page")}`,value: n})),

			fields: [
				{ key: "id", label: this.$t("globals.id"), sortable: true },
				{ key: "service_id", label: this.$t("globals.service"), sortable: false },
				{ key: "service_device_type", label: this.$t("globals.device_type"), sortable: true },
				{ key: "fieldtracker_reference", label: this.$t("globals.fieldtracker_reference"), sortable: true },
				{ key: "status", label: this.$t("globals.status"), sortable: true },
				{ key: "created_at", label: this.$t("globals.created_at"), sortable: true }
			]
		};
	}
};

</script>